import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_LEAD_REDUX]'; // eslint-disable-line

const functionDefinitions = {
    /*---------- getLeads --------*/

    requestGetLeads: ['userId'],
    getLeadsSuccess: ['getLeadsResponse'],
    getLeadsFailure: ['getLeadsError'],


    /*---------- updateLeadBatch --------*/

    requestUpdateLeadBatch: ['updateLeadBatch'],
    updateLeadBatchSuccess: ['updateLeadBatchResponse'],
    updateLeadBatchFailure: ['updateLeadBatchError'],

    /*---------- generateLeadReport --------*/

    requestGenerateLeadReport: ['leadReportInput'],
    generateLeadReportSuccess: ['generateLeadReportResponse'],
    generateLeadReportFailure: ['generateLeadReportError'],

    /*---------- getLeadDetail --------*/

    requestGetLeadDetail:['leadId','propertyId'],
    getLeadDetailSuccess:['getLeadDetailResponse'],
    getLeadDetailFailure:['getLeadDetailError'],

    /*---------- updateLeadDetail --------*/
    
    requestUpdateLeadDetail:['leadDetail'],
    updateLeadDetailSuccess:['updateLeadDetailResponse'],
    updateLeadDetailFailure:['updateLeadDetailError'],

    /*---------- removeLeadDetail --------*/
    
    requestRemoveLeadDetail:['leadId'],
    removeLeadDetailSuccess:['removeLeadDetailResponse'],
    removeLeadDetailFailure:['removeLeadDetailError'],

    /*---------- createLeadByEnquiry --------*/
    
    requestCreateLeadByEnquiry:['enquiryId','propertyId','userId'],
    createLeadByEnquirySuccess:['createLeadByEnquiryResponse'],
    createLeadByEnquiryFailure:['createLeadByEnquiryError'],

    /*---------- deleteLeads --------*/
    
    requestDeleteLeads:['leadIds'],
    deleteLeadsSuccess:['deleteLeadsResponse'],
    deleteLeadsFailure:['deleteLeadsError'],

    /*---------- getLeadsByProperty --------*/
    
    requestGetLeadsByProperty:['propertyId'],
    getLeadsByPropertySuccess:['getLeadsByPropertyResponse'],
    getLeadsByPropertyFailure:['getLeadsByPropertyError'],

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaLeadTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaLeadInitState = {};

export const INITIAL_STATE = Immutable(SagaLeadInitState);

/* ------------- Reducers ------------- */


/*---------- getLeads --------*/


export const requestGetLeads = (state, action) => {
    return state.merge(
        {
            getLeadsFetching: true,
            userId: action.userId,

        });
};
export const getLeadsSuccess = (state, action) => {
    return state.merge(
        {
            getLeadsFetching: false,
            getLeadsResponse: action.getLeadsResponse,
            getLeadsError: null,
            generateLeadReportError: null
        });
};
export const getLeadsFailure = (state, action) => {
    return state.merge(
        {
            getLeadsFetching: false,
            getLeadsError: action.getLeadsError,

        });
};


/*---------- updateLeadBatch --------*/


export const requestUpdateLeadBatch = (state, action) => {
    return state.merge(
        {
            updateLeadBatchFetching: true,
            updateLeadBatch: action.updateLeadBatch,
        });
};
export const updateLeadBatchSuccess = (state, action) => {
    return state.merge(
        {
            updateLeadBatchFetching: false,
            updateLeadBatchResponse: action.updateLeadBatchResponse,
            getLeadsResponse: action.updateLeadBatchResponse,
            updateLeadBatchError: null
        });
};
export const updateLeadBatchFailure = (state, action) => {
    return state.merge(
        {
            updateLeadBatchFetching: false,
            updateLeadBatchError: action.updateLeadBatchError,

        });
};


/*---------- generateLeadReport --------*/


export const requestGenerateLeadReport = (state, action) => {
    return state.merge(
        {
            generateLeadReportFetching: true,
            leadReportInput: action.leadReportInput,

        });
};
export const generateLeadReportSuccess = (state, action) => {
    return state.merge(
        {
            generateLeadReportFetching: false,
            generateLeadReportResponse: action.generateLeadReportResponse,
            generateLeadReportError: null
        });
};
export const generateLeadReportFailure = (state, action) => {
    return state.merge(
        {
            generateLeadReportFetching: false,
            generateLeadReportError: action.generateLeadReportError,

        });
};

/*---------- getLeadDetail --------*/


export const requestGetLeadDetail = (state,action) => {
    return state.merge(
      {
          getLeadDetailFetching:true,
          leadId:action.leadId,
          propertyId:action.propertyId,
          getLeadDetailError:null,
          getLeadDetailResponse:null,
          
      });
  };
  export const getLeadDetailSuccess = (state,action) => {
    return state.merge(
      {
          getLeadDetailFetching:false,
          getLeadDetailResponse:action.getLeadDetailResponse,
          
      });
  };
  export const getLeadDetailFailure = (state,action) => {
    return state.merge(
      {
          getLeadDetailFetching:false,
          getLeadDetailError:action.getLeadDetailError,
          
      });
  };

/*---------- updateLeadDetail --------*/


export const requestUpdateLeadDetail = (state,action) => {
  return state.merge(
    {
        updateLeadDetailFetching:true,
        leadDetail:action.leadDetail,
        updateLeadDetailError:null,
        updateLeadDetailResponse:null,
        
    });
};
export const updateLeadDetailSuccess = (state,action) => {
  return state.merge(
    {
        updateLeadDetailFetching:false,
        updateLeadDetailResponse:action.updateLeadDetailResponse,
        updateLeadDetailError:null,
        
    });
};
export const updateLeadDetailFailure = (state,action) => {
  return state.merge(
    {
        updateLeadDetailFetching:false,
        updateLeadDetailError:action.updateLeadDetailError,
        
    });
};

/*---------- removeLeadDetail --------*/


export const requestRemoveLeadDetail = (state,action) => {
  return state.merge(
    {
        removeLeadDetailFetching:true,
        leadId:action.leadId,
        removeLeadDetailError:null,
        removeLeadDetailResponse:null,
        
    });
};
export const removeLeadDetailSuccess = (state,action) => {
  return state.merge(
    {
        removeLeadDetailFetching:false,
        removeLeadDetailResponse:action.removeLeadDetailResponse,
        
    });
};
export const removeLeadDetailFailure = (state,action) => {
  return state.merge(
    {
        removeLeadDetailFetching:false,
        removeLeadDetailError:action.removeLeadDetailError,
        
    });
};


/*---------- createLeadByEnquiry --------*/


export const requestCreateLeadByEnquiry = (state,action) => {
    return state.merge(
      {
          createLeadByEnquiryFetching:true,
          enquiryId:action.enquiryId,
          propertyId:action.propertyId,
          userId:action.userId,
          createLeadByEnquiryResponse: null,
          createLeadByEnquiryError: null
      });
  };
  export const createLeadByEnquirySuccess = (state,action) => {
    return state.merge(
      {
          createLeadByEnquiryFetching:false,
          createLeadByEnquiryResponse:action.createLeadByEnquiryResponse,
          
      });
  };
  export const createLeadByEnquiryFailure = (state,action) => {
    return state.merge(
      {
          createLeadByEnquiryFetching:false,
          createLeadByEnquiryError:action.createLeadByEnquiryError,
          
      });
  };

  /*---------- deleteLeads --------*/
  
  
  export const requestDeleteLeads = (state,action) => {
    return state.merge(
      {
          deleteLeadsFetching:true,
          leadIds:action.leadIds,
          deleteLeadsResponse:null,
          deleteLeadsError:null,
          
      });
  };
  export const deleteLeadsSuccess = (state,action) => {
    return state.merge(
      {
          deleteLeadsFetching:false,
          deleteLeadsResponse:action.deleteLeadsResponse,
          getLeadsResponse: action.deleteLeadsResponse,
          
      });
  };
  export const deleteLeadsFailure = (state,action) => {
    return state.merge(
      {
          deleteLeadsFetching:false,
          deleteLeadsError:action.deleteLeadsError,
          
      });
  };

  /*---------- getLeadsByProperty --------*/
  
  
  export const requestGetLeadsByProperty = (state,action) => {
    return state.merge(
      {
          getLeadsByPropertyFetching:true,
          propertyId:action.propertyId,
          getLeadsByPropertyError:null,
          getLeadsByPropertyResponse:null,
      });
  };
  export const getLeadsByPropertySuccess = (state,action) => {
    return state.merge(
      {
          getLeadsByPropertyFetching:false,
          getLeadsByPropertyResponse:action.getLeadsByPropertyResponse,
          getLeadsByPropertyError:null,
          
      });
  };
  export const getLeadsByPropertyFailure = (state,action) => {
    return state.merge(
      {
          getLeadsByPropertyFetching:false,
          getLeadsByPropertyError:action.getLeadsByPropertyError,
          
      });
  };
  
  
  

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- getLeads --------*/

    [Types.REQUEST_GET_LEADS]: requestGetLeads,
    [Types.GET_LEADS_SUCCESS]: getLeadsSuccess,
    [Types.GET_LEADS_FAILURE]: getLeadsFailure,

    /*---------- updateLeadBatch --------*/

    [Types.REQUEST_UPDATE_LEAD_BATCH]: requestUpdateLeadBatch,
    [Types.UPDATE_LEAD_BATCH_SUCCESS]: updateLeadBatchSuccess,
    [Types.UPDATE_LEAD_BATCH_FAILURE]: updateLeadBatchFailure,

    /*---------- generateLeadReport --------*/

    [Types.REQUEST_GENERATE_LEAD_REPORT]: requestGenerateLeadReport,
    [Types.GENERATE_LEAD_REPORT_SUCCESS]: generateLeadReportSuccess,
    [Types.GENERATE_LEAD_REPORT_FAILURE]: generateLeadReportFailure,

    /*---------- getLeadDetail --------*/
    
    [Types.REQUEST_GET_LEAD_DETAIL]: requestGetLeadDetail,
    [Types.GET_LEAD_DETAIL_SUCCESS]: getLeadDetailSuccess,
    [Types.GET_LEAD_DETAIL_FAILURE]: getLeadDetailFailure,

    /*---------- updateLeadDetail --------*/

    [Types.REQUEST_UPDATE_LEAD_DETAIL]: requestUpdateLeadDetail,
    [Types.UPDATE_LEAD_DETAIL_SUCCESS]: updateLeadDetailSuccess,
    [Types.UPDATE_LEAD_DETAIL_FAILURE]: updateLeadDetailFailure,

    /*---------- removeLeadDetail --------*/
    
    [Types.REQUEST_REMOVE_LEAD_DETAIL]: requestRemoveLeadDetail,
    [Types.REMOVE_LEAD_DETAIL_SUCCESS]: removeLeadDetailSuccess,
    [Types.REMOVE_LEAD_DETAIL_FAILURE]: removeLeadDetailFailure,

    /*---------- createLeadByEnquiry --------*/
    
    [Types.REQUEST_CREATE_LEAD_BY_ENQUIRY]: requestCreateLeadByEnquiry,
    [Types.CREATE_LEAD_BY_ENQUIRY_SUCCESS]: createLeadByEnquirySuccess,
    [Types.CREATE_LEAD_BY_ENQUIRY_FAILURE]: createLeadByEnquiryFailure,

    /*---------- deleteLeads --------*/
    
    [Types.REQUEST_DELETE_LEADS]: requestDeleteLeads,
    [Types.DELETE_LEADS_SUCCESS]: deleteLeadsSuccess,
    [Types.DELETE_LEADS_FAILURE]: deleteLeadsFailure,

    /*---------- getLeadsByProperty --------*/
    
    [Types.REQUEST_GET_LEADS_BY_PROPERTY]: requestGetLeadsByProperty,
    [Types.GET_LEADS_BY_PROPERTY_SUCCESS]: getLeadsByPropertySuccess,
    [Types.GET_LEADS_BY_PROPERTY_FAILURE]: getLeadsByPropertyFailure,
    
    

});



// WEBPACK FOOTER //
// ./src/redux/sagaLead/sagaLeadRedux.ts